import { TypePublicationDTO, ExtrachargeDTO } from '@app/src/views/StepTwo/channelPublication/dto/TypePublicationDTO';
import { TypePublicationModel, InputExtrachargeModel } from '@app/src/views/StepTwo/channelPublication/models/typePublication';
import { EXTRACHARGE } from '@app/src/views/StepTwo/channelPublication/state/typePublication/constants';

export const hydrateData = (data: TypePublicationDTO[]) => {
  const publications = {};
  data.map((item: TypePublicationDTO) => {
    publications[`${item.id}`] = {
      publicationDay: item.publication_day,
      name: item.name,
      allowDay: getNumberValue(item.allow_day),
      alias: item.alias,
      state: item.state,
      description: item.description,
      closeHour: getNumberValue(item.close_hour),
      id: item.id,
      closeDay: getNumberValue(item.close_day),
      price: item.price,
      priceIgv: item.price_igv,
      packageId: item.package_id,
      newspaperId: item.newspaper_id,
      details: [],
      extracharge: hydrateExtracharge(item.extracharge)
    };
  });
  return publications as TypePublicationModel[];
};

export const hydrateExtracharge = (data: ExtrachargeDTO[]) => data && data.map(item => {
  if (item.alias === 'fotovineta' || item.alias === 'palabra-extra') {
    return ({
      alias: item.alias,
      name: item.name,
      price: item.price,
      priceIgv: item.price_igv,
      input: EXTRACHARGE[item.alias] && EXTRACHARGE[item.alias].input,
      value: item.id,
      style: EXTRACHARGE[item.alias] && EXTRACHARGE[item.alias].style,
      styleValue: EXTRACHARGE[item.alias] && EXTRACHARGE[item.alias].styleValue,
      disabled: true,
      checked: false
    }) as InputExtrachargeModel
  }
  return ({
    alias: item.alias,
    name: item.name,
    price: item.price,
    priceIgv: item.price_igv,
    input: EXTRACHARGE[item.alias] && EXTRACHARGE[item.alias].input,
    value: item.id,
    style: EXTRACHARGE[item.alias] && EXTRACHARGE[item.alias].style,
    styleValue: EXTRACHARGE[item.alias] && EXTRACHARGE[item.alias].styleValue,
    disabled: false,
    checked: false
})}) as InputExtrachargeModel[];

const getNumberValue = (value: string) => {
  if (value.includes(',')) {
    let arrayNumber: number[] = [];
    const arrayString = value.split(',');
    for (let i = 0; i < arrayString.length; i++) {
      arrayNumber.push(parseInt(arrayString[i], 10));
    }
    return arrayNumber;
  }
  return Number(value);
};
